import styled from 'styled-components';
import { List } from '@cko/primitives';

export const StyledLevelTwoGroupingContainer = styled(List)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--layout-seed) var(--layout-sandgrain);
  padding-top: var(--layout-soapbar);

  &:first-child {
    padding-top: var(--layout-stamp);
  }
`;

export const StyledText = styled.div`
  font: var(--heading-grouping);
  text-transform: var(--text-loud);
  padding-left: var(--layout-soapbar);
  letter-spacing: 3px;
`;
